module.exports = __webpack_public_path__ + "media/images/steps/face_shield_step1-9659ee24275d3bc1b6e10a3f0f84e6de.svg";